import { entityEndpointMap } from 'bento-ordering/base/constants/endpoints';
import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILURE
} from 'bento-ordering/base/actions/actionTypes';

export const fetchSingleEntity = (entityType, endpoint, queryParams = {}) => {
  const entityEndpoint = endpoint || entityEndpointMap[entityType];
  const types = [
    { type: `[${entityType}] ${FETCH_REQUEST}` },
    {
      type: `[${entityType}] ${FETCH_SUCCESS}`,
      meta: { lastFetched: Date.now() }
    },
    { type: `[${entityType}] ${FETCH_FAILURE}` }
  ];

  return apiAction(entityEndpoint, 'GET', types, null, queryParams);
};
